import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/answers';
const dependantUrl = '/capsiminbox/admin/api/dependsOn';

export const addAnswer = async ({ payload }) =>
  await ajax('POST', `${rootUrl}`, JSON.stringify(payload));

export const updateAnswer = async ({ answerKey, answer }) =>
  await ajax('PUT', `${rootUrl}/${answerKey}`, JSON.stringify({ answer }));

export const deleteAnswer = async ({ answerKey }) =>
  await ajax('DELETE', `${rootUrl}/${answerKey}`);

export const addSkillToAnswer = async ({ payload }) =>
  await ajax('POST', `${rootUrl}/ats`, JSON.stringify(payload));

export const updateSkillToAnswer = async ({ payload }) =>
  await ajax('PUT', `${rootUrl}/ats`, JSON.stringify(payload));

export const deleteSkillFromAnswer = async ({ payload }) =>
  await ajax('DELETE', `${rootUrl}/ats`, JSON.stringify(payload));

export const addAnswerDependant = async ({ payload }) =>
  await ajax('POST', `${dependantUrl}`, JSON.stringify(payload));

export const updateAnswerDependant = async ({ payload }) =>
  await ajax('PUT', `${dependantUrl}`, JSON.stringify(payload));

export const deleteAnswerDependant = async ({ payload }) =>
  await ajax('DELETE', `${dependantUrl}`, JSON.stringify(payload));
